import React from 'react'
import { NavLink } from 'react-router-dom'
import { SidebarIcon } from '../icons/SidebarIcons'
import type { SidebarIconName } from '../icons/SidebarIcons'
import clsx from 'clsx'

interface SidebarNavItemProps {
  to: string
  label: string
  icon: SidebarIconName
  badge?: number // Optional badge count (e.g., hot prospects)
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({ to, label, icon, badge }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          'group flex items-center gap-3 px-4 h-11 rounded-[10px] dash-body-m transition-colors select-none relative',
          'text-[var(--text-secondary)] hover:text-[var(--text-primary)]',
          isActive && 'text-[var(--text-primary)]'
        )
      }
      end
    >
      {({ isActive }) => (
        <>
          <span
            aria-hidden
            className={clsx(
              'absolute inset-0 rounded-[10px] -z-10 transition-colors',
              'bg-transparent group-hover:bg-[var(--surface-hover)]',
              isActive && 'bg-[var(--surface-active)]'
            )}
          />
          <span
            aria-hidden
            className={clsx(
              'absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-6 rounded-full bg-[var(--accent-strong)] transition-opacity',
              isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-40'
            )}
          />
          <SidebarIcon
            name={icon}
            className={clsx(
              'w-5 h-5 transition-colors',
              isActive ? 'text-[var(--accent-strong)]' : 'text-[var(--text-tertiary)] group-hover:text-[var(--text-secondary)]'
            )}
          />
          <span className="truncate flex-1">{label}</span>
          {badge !== undefined && badge > 0 && (
            <span
              className="flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-medium bg-[var(--state-danger)] text-white"
              aria-label={`${badge} items`}
            >
              {badge > 99 ? '99+' : badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  )
}
